import React from "react";
import { StarIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { TrustRow } from "./TrustRow";
import { plans } from "../data/plans";
import type { PlanId } from "../types/pricing";
type PricingCardsProps = {
  plan: PlanId;
  onPlanChange: (plan: PlanId) => void;
  premiumNote: string;
  name: string;
};
export function PricingCards({
  plan,
  onPlanChange,
  premiumNote,
  name
}: PricingCardsProps) {
  const selected = plans.find(p => p.id === plan) ?? plans[0];
  return <div className="mx-auto w-full max-w-xl" data-id="element-269" data-mp="2fe44uduuir85">
      <div role="radiogroup" aria-label="Elegí tu Megapack" className="flex flex-col gap-2.5 md:gap-3" data-id="element-270" data-mp="2fcszwapnzdfg">
        {plans.map(p => {
        const active = p.id === plan;
        return <label key={p.id} className={`relative flex cursor-pointer items-center gap-3 rounded-2xl p-4 transition-[background-color,box-shadow,color] duration-150 ease-out md:gap-4 md:p-5 ${active ? "bg-forest text-paper ring-2 ring-gold shadow-[0_18px_40px_-24px_rgba(24,38,30,0.7)]" : "bg-paper text-ink ring-1 ring-line hover:ring-forest/40"}`} data-id="element-271" data-mp="2p3xhzjamzeei">
              <input type="radio" name={name} value={p.id} checked={active} onChange={() => onPlanChange(p.id)} className="peer sr-only" data-id="element-272" data-mp="3jjrs4zy3wum4" />
              <span aria-hidden className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full ring-2 transition-colors duration-150 peer-focus-visible:ring-offset-2 ${active ? "ring-gold" : "ring-line"}`} data-id="element-273" data-mp="g3ugsno7lgm7">
                <span className={`h-2.5 w-2.5 rounded-full transition-transform duration-150 ease-out ${active ? "scale-100 bg-gold" : "scale-0"}`} data-id="element-274" data-mp="28scg4z0fzbi" />
              </span>
              <span className="min-w-0 flex-1" data-id="element-275" data-mp="u080m3g7tu3u">
                {p.popular && <span className="mb-1.5 flex flex-wrap items-center gap-1.5" data-id="element-276" data-mp="2oaxymkhpnsm7">
                    <span className="inline-flex items-center gap-1 rounded-full bg-gold px-2 py-0.5 text-[10px] font-bold tracking-wider text-forestDeep md:text-[11px]" data-id="element-277" data-mp="2t8zg50zhnjvk">
                      <StarIcon className="h-2.5 w-2.5 fill-forestDeep" aria-hidden data-id="element-278" data-mp="2jiwop580mdzc" /> MÁS ELEGIDO
                    </span>
                    <span className="rounded-full bg-wine px-2 py-0.5 text-[10px] font-bold tracking-wider text-paper md:text-[11px]" data-id="element-279" data-mp="25ivq5wf83in1">
                      AHORRÁS $15.000
                    </span>
                  </span>}
                <span className={`block font-display text-xl leading-tight md:text-2xl ${active ? "text-paper" : "text-forest"}`} data-id="element-280" data-mp="1vmsdvxqnq3md">{p.name}</span>
                <span className={`block text-[13px] md:text-sm ${active ? "text-paper/70" : "text-muted"}`} data-id="element-281" data-mp="3pz8iyv7pvbpn">{p.detail}</span>
              </span>
              <span className="shrink-0 text-right" data-id="element-282" data-mp="3uxjr91id5e5r">
                <span className={`block text-xs line-through md:text-sm ${active ? "text-paper/50" : "text-muted"}`} data-id="element-283" data-mp="1jaggsd021pp1">{p.compare}</span>
                <span className={`block font-display text-3xl leading-none md:text-4xl ${active ? "text-goldSoft" : "text-forest"}`} data-id="element-284" data-mp="1ecy5wh2h90ee">{p.price}</span>
              </span>
            </label>;
      })}
      </div>
      <div className="mt-4 md:mt-5" data-id="element-285" data-mp="1o8i2l5ov8347">
        <CTAButton href={selected.checkoutUrl} tone="wine" full data-id="element-286" data-mp="220xyznn9h2w5">
          {selected.cta}
        </CTAButton>
        <p className="mt-2 min-h-[1rem] text-center text-xs text-muted md:text-[13px]" data-id="element-287" data-mp="1y05nsoutwnx8">
          {selected.popular ? premiumNote : "Las dos opciones incluyen los 3 bonos completos"}
        </p>
      </div>
      <div className="mt-3 flex justify-center" data-id="element-288" data-mp="27012h3nlf120">
        <TrustRow data-id="element-289" data-mp="26y7thhpic4qu" />
      </div>
    </div>;
}